import { render, staticRenderFns } from "./SpecificExaminationsBlock.vue?vue&type=template&id=19a0e732&lang=pug&"
import script from "./SpecificExaminationsBlock.vue?vue&type=script&lang=js&"
export * from "./SpecificExaminationsBlock.vue?vue&type=script&lang=js&"
import style0 from "./SpecificExaminationsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports